"use client";
import React, { useEffect, useState } from 'react';
import Link from 'next/link';

const PopularArticles = () => {
    const [popularArticles, setPopularArticles] = useState([]);

    // Fonction pour récupérer les articles populaires
    const fetchPopularArticles = async () => {
        try {
            const response = await fetch(`${process.env.NEXT_PUBLIC_BASE_URL}/api/articles/popular`);
            if (!response.ok) {
                throw new Error('Erreur lors de la récupération des articles populaires');
            }
            const articles = await response.json();
            setPopularArticles(articles);
        } catch (error) {
            console.error('Erreur :', error);
        }
    };

    useEffect(() => {
        fetchPopularArticles();
    }, []);

    return (
        <section>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8">Articles populaires</h2>
            {popularArticles.length === 0 ? (
                <p className="text-center text-[#555]">Aucun article disponible pour l&apos;instant.</p>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
                    {popularArticles.map((article, index) => (
                        <Link key={article._id} href={`/articles/${article.slug}`} className="group">
                            <div className="bg-white border border-[#D4DDD1] rounded-2xl p-5 shadow-sm hover:shadow-lg transition-all duration-300 group-hover:border-[#2C6E63]/30 flex items-start gap-3">
                                <span className="w-8 h-8 bg-[#2C6E63]/10 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold text-[#2C6E63]">
                                    {index + 1}
                                </span>
                                <p className="text-sm text-[#555] leading-relaxed group-hover:text-[#2C6E63] transition-colors">
                                    {article.title}
                                </p>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </section>
    );
};

export default PopularArticles;


